import { ANYSPEND_EVM_CHAINS } from "@b3/chain-registry";
import { toThirdwebChain, toViemChain } from "../../../shared/utils/chain-transformers.js";
import invariant from "invariant";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import coingeckoChainsJSON from "../../generated/coingecko-chains.json" with { type: "json" };
export const supportedChains = ANYSPEND_EVM_CHAINS.map(toViemChain);
export const supportedChainsTW = ANYSPEND_EVM_CHAINS.map(toThirdwebChain);
export const supportedChainNetworks = ANYSPEND_EVM_CHAINS;
export const coingeckoChains = coingeckoChainsJSON;
export function getCoingeckoChainInfo(chainId) {
    return coingeckoChains[chainId];
}
const _b3MainnetThirdWeb = supportedChainsTW.find(c => c.id === 8333);
invariant(_b3MainnetThirdWeb, "B3 mainnet chain not found in supported chains TW");
export const b3MainnetThirdWeb = _b3MainnetThirdWeb;
const _b3Mainnet = supportedChains.find(c => c.id === 8333);
invariant(_b3Mainnet, "B3 mainnet chain not found in supported chains");
export const b3Mainnet = _b3Mainnet;
const _baseMainnet = supportedChains.find(c => c.id === 8453);
invariant(_baseMainnet, "Base mainnet chain not found in supported chains");
export const baseMainnet = _baseMainnet;
export function getThirdwebChain(chainId) {
    const chain = supportedChainsTW.find(c => c.id === chainId);
    if (!chain) {
        throw new Error(`Chain ${chainId} is not supported`);
    }
    return chain;
}
export function getChainLogo(chainId) {
    return getThirdwebChain(chainId)?.icon?.url || "";
}
